import { createAction, createAsyncAction } from "typesafe-actions";
import { IJob, IJobListTimestampRange, IJobRequest, IJobs, IOrgJobListRequest, ICreateJobRequest, IUpdateJobRequest, IUpdateLocalJobInfoRequest, IUpdateRpiJobStatusRequest, IUserJobListRequest, IQueueJobRequest, IUpdateJobResultRequest, IProcessLocalJobRequest, IProcessLocalAveragingJobRequest } from "../../models";

export const setJobRequest = createAction('SET_JOB_REQUEST')<IJobRequest>();
export const setJobId = createAction('SET_JOB_ID')<string>();
export const updateRpiJobStatus = createAction('UPDATE_RPI_JOB_STATUS')<IUpdateRpiJobStatusRequest>();
export const setWaitingForScan = createAction('SET_WAITING_FOR_SCAN')<boolean>();
export const upsertOptimisticUserJob = createAction('UPSERT_OPTIMISTIC_USER_JOB')<IJob>();

export const setUserJobsTimestampRange = createAction('SET_USER_JOBS_TIMESTAMP_RANGE')<IJobListTimestampRange>();
export const setOrgJobsTimestampRange = createAction('SET_ORG_JOBS_TIMESTAMP_RANGE')<IJobListTimestampRange>();

export const reset = createAction('RESET')<void>();
export const clearJobInfo = createAction('CLEAR_JOB_INFO')<void>();

export const setDraftJobId = createAction('SET_DRAFT_JOB_ID')<string>();
export const newDraftReading = createAction('NEW_DRAFT_READING')<string>();
export const setDraftLocked = createAction('SET_DRAFT_LOCKED')<boolean>();
export const setDraftInfoField = createAction('SET_DRAFT_INFO_FIELD')<{ fieldName: string; value: string }>();
export const clearDraftInfo = createAction('CLEAR_DRAFT_INFO')<void>();
export const commitDraftInfoForJob = createAction('COMMIT_DRAFT_INFO_FOR_JOB')<{ jobId: string; info: { [key: string]: string } }>();
export const clearCommittedDraftInfo = createAction('CLEAR_COMMITTED_DRAFT_INFO')<string>();

export const createJob = createAsyncAction(
    "job/CREATE_JOB_REQUEST",
    "job/CREATE_JOB_SUCCESS",
    "job/CREATE_JOB_FAILURE"
)<ICreateJobRequest, Boolean | null, Error>();

// retrials or test job
export const queueJob = createAsyncAction(
    "job/QUEUE_JOB_REQUEST",
    "job/QUEUE_JOB_SUCCESS",
    "job/QUEUE_JOB_FAILURE"
)<IQueueJobRequest, Boolean | null, Error>();

export const updateJob = createAsyncAction(
    "job/UPDATE_JOB_REQUEST",
    "job/UPDATE_JOB_SUCCESS",
    "job/UPDATE_JOB_FAILURE"
)<IUpdateJobRequest, Boolean | null, Error>();

export const updateLocalJobInfo = createAsyncAction(
    "job/UPDATE_LOCAL_JOB_INFO_REQUEST",
    "job/UPDATE_LOCAL_JOB_INFO_SUCCESS",
    "job/UPDATE_LOCAL_JOB_INFO_FAILURE"
)<IUpdateLocalJobInfoRequest, Boolean | null, Error>();

export const updateJobResult = createAsyncAction(
    "job/UPDATE_JOB_RESULT_REQUEST",
    "job/UPDATE_JOB_RESULT_SUCCESS",
    "job/UPDATE_JOB_RESULT_FAILURE"
)<IUpdateJobResultRequest, Boolean | null, Error>();

export const userJobs = createAsyncAction(
    "job/USER_JOBS_REQUEST",
    "job/USER_JOBS_SUCCESS",
    "job/USER_JOBS_FAILURE"
)<IUserJobListRequest, IJobs | null, Error>();

export const orgJobs = createAsyncAction(
    "job/ORG_JOBS_REQUEST",
    "job/ORG_JOBS_SUCCESS",
    "job/ORG_JOBS_FAILURE"
)<IOrgJobListRequest, IJobs | null, Error>();

export const jobStatus = createAsyncAction(
    "job/JOB_STATUS_REQUEST",
    "job/JOB_STATUS_SUCCESS",
    "job/JOB_STATUS_FAILURE"
)<string, IJob | null, Error>();

export const pollJobStatus = createAsyncAction(
    "job/POLL_JOB_STATUS_REQUEST",
    "job/POLL_JOB_STATUS_SUCCESS",
    "job/POLL_JOB_STATUS_FAILURE"
)<string, IJob | null, Error>();

export const processLocalJob = createAsyncAction(
    "job/PROCESS_LOCAL_JOB_REQUEST",
    "job/PROCESS_LOCAL_JOB_SUCCESS",
    "job/PROCESS_LOCAL_JOB_FAILURE"
)<IProcessLocalJobRequest, IJob, Error>();

export const processLocalAveragingJob = createAsyncAction(
    "job/PROCESS_LOCAL_AVERAGING_JOB_REQUEST",
    "job/PROCESS_LOCAL_AVERAGING_JOB_SUCCESS",
    "job/PROCESS_LOCAL_AVERAGING_JOB_FAILURE"
)<IProcessLocalAveragingJobRequest, IJob, Error>();

export const getLocalJob = createAsyncAction(
    "job/GET_LOCAL_JOB_REQUEST",
    "job/GET_LOCAL_JOB_SUCCESS",
    "job/GET_LOCAL_JOB_FAILURE"
)<string, IJob | null, Error>();

export const pollUserJobs = createAsyncAction(
    "job/POLL_USER_JOBS_REQUEST",
    "job/POLL_USER_JOBS_SUCCESS",
    "job/POLL_USER_JOBS_FAILURE"
)<IUserJobListRequest, IJobs | null, Error>();

export const pollOrgJobs = createAsyncAction(
    "job/POLL_ORG_JOBS_REQUEST",
    "job/POLL_ORG_JOBS_SUCCESS",
    "job/POLL_ORG_JOBS_FAILURE"
)<IOrgJobListRequest, IJobs | null, Error>();

export const deleteJob = createAsyncAction(
    "job/DELETE_JOB_REQUEST",
    "job/DELETE_JOB_SUCCESS",
    "job/DELETE_JOB_FAILURE"
)<string, Boolean | null, Error>();

// Selection mode actions for averaging feature
export const toggleSelectionMode = createAction('TOGGLE_SELECTION_MODE')<void>();
export const selectJob = createAction('SELECT_JOB')<string>();
export const deselectJob = createAction('DESELECT_JOB')<string>();
export const clearSelection = createAction('CLEAR_SELECTION')<void>();
export const selectAllJobs = createAction('SELECT_ALL_JOBS')<string[]>();
